import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { LlContactsService  } from '../ll-contacts.service';
import { LlScrollpaneService } from '../ll-scrollpane.service';
import { LlPermissionsService } from '../ll-permissions.service';
import { LlCompaniesService } from '../ll-companies.service';
import { jqxPanelComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxpanel'
import { jqxPopoverComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxpopover";
import { jqxTextAreaComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxtextarea";
import { fromEvent } from 'rxjs';
import { filter } from "../utility-search";
import { removeCarriageReturn } from "../utility";

@Component({
  selector: 'll-contacts-sp',
  templateUrl: './ll-contacts-sp.component.html',
  styleUrls: ['../cssMain.css']
})

export class LlContactsSpComponent implements OnInit {

  @ViewChild('mainDiv_ll_contacts_sp') private mainDiv: ElementRef;
  @ViewChild('vertTab_ll_contacts_sp') private vertTab: ElementRef;
  @ViewChild('scrollpane_ll_contacts_sp') private SP: jqxPanelComponent;
  @ViewChild('popover_search') private popover_search: jqxPopoverComponent;
  @ViewChild('text_search') private text_search: jqxTextAreaComponent;
  @ViewChild('popover_addContact') private popover_addContact: jqxPopoverComponent;
  @ViewChild('text_contactEmail') private text_contactEmail: jqxTextAreaComponent;
  @ViewChild('text_contactFirst') private text_contactFirst: jqxTextAreaComponent;
  @ViewChild('text_contactLast') private text_contactLast: jqxTextAreaComponent;

  constructor(
    private LlContactsService: LlContactsService,
    private LlCompaniesService: LlCompaniesService,
    private LlScrollpaneService: LlScrollpaneService,
    private LlPermissionsService: LlPermissionsService,

  ) { }

  bundle = {
    lable: "Users",
    prefix: "CT",
    selectedId: -1,
    selectedId_ondeck: -1,
    showObj: true,//false,
    showRemaining: false,
    scrolling: false,
    canAdd: false,
    canEdit: false,
    canFilter: true,
    searchText: "",
    LlContactsService: this.LlContactsService,
    popover_addContact: {},
    getData: {},
    records: [],
    origionalRecords: [],  
    parentW: 0,
    parentH: 0,
    remainingX: 0,
    remainingY: 0,
    remainingW: 0,
    remainingH: 0,
    SPYPosition: 0,
    ctx: {},
    showTab: true,
    objH: 0,
    lblY: 20,
    topOffset: 0,
    spY: 0,
    spW: 130,
    spH: 0,
    spB: 0,
    lineWidth: 1,
    vertLineX: 0,
    vertLineY: -1,
    vertLineW: 20,
    vertLineH: 0,
    tabY: 0,
    tabW: 0,
    tabH: 18,
    Tooltip01: 'not Found',
    newUserMsg: '',
  }

  ngOnInit() { }

  eventSubscription_refreshContactList: any;

  ngOnDestroy() {
    this.eventSubscription_refreshContactList.unsubscribe();
  }

  ngAfterViewInit() {

    fromEvent(this.mainDiv.nativeElement, 'mousemove')
      .subscribe(res => {
        let value = this.SP.getVScrollPosition();

        if (value != this.bundle.SPYPosition) {
          this.bundle.SPYPosition = value;

          this.bundle.scrolling = true;

          document.getElementById(this.bundle.prefix + this.bundle.selectedId.toString()).click();
        }
      }
      );

    fromEvent(this.mainDiv.nativeElement, 'wheel')
      .subscribe(res => {
        let value = this.SP.getVScrollPosition();

        if (value != this.bundle.SPYPosition) {
          this.bundle.SPYPosition = value;

          this.bundle.scrolling = true;

          document.getElementById(this.bundle.prefix + this.bundle.selectedId.toString()).click();
        }
      }
    );

    this.eventSubscription_refreshContactList = this.LlContactsService.refreshContactList.subscribe(action => {
      this.getData('new', this.bundle);
    });

    this.setVars();
  }

  setVars() {

    if (this.LlCompaniesService.getActiveCompanyId() != 0) {
      this.bundle.canAdd = this.LlPermissionsService.check("addUser");
    }

    this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;

    

    setTimeout(() => {

      this.LlScrollpaneService.standardDimentions(this.bundle);

      var canvasEl: HTMLCanvasElement = this.vertTab.nativeElement;
      canvasEl.width = this.bundle.vertLineX + this.bundle.vertLineW;
      canvasEl.height = this.bundle.vertLineH;
      this.bundle.ctx = canvasEl.getContext('2d');

      setTimeout(() => {

        this.LlScrollpaneService.standardRemainderValues(this.bundle, canvasEl);
    
        this.getData('new', this.bundle);
      });
    });
  }

  getData(type, bundle) {

    if (type == 'new'){
      this.LlContactsService.NG_LL_contact_all_get(done01, bundle);
    } else {
      this.LlContactsService.getExistingContacts(done01, bundle);
    }
    

    function done01(records, bundle) {

      bundle.records = records;
      bundle.origionalRecords = records;
   
      let selectedId_initial = bundle.LlContactsService.getActiveContactId();

      setTimeout(() => {

        bundle.showObj = true;

        setTimeout(() => {

          if (selectedId_initial != null && document.getElementById(bundle.prefix + selectedId_initial.toString()) != null) {
            document.getElementById(bundle.prefix + selectedId_initial.toString()).click();
          }

        });
      });
    }
  }

  select(event) {

    //console.log("select")

    this.bundle = this.LlScrollpaneService.bundle(event, this.bundle, this.SP)

    this.LlScrollpaneService.paintVertTab(this.bundle);

    if (this.bundle.scrolling == true) {

      this.bundle.scrolling = false;

    } else {

      this.bundle.showRemaining = false;

      setTimeout(() => {

        this.bundle.selectedId = this.bundle.selectedId_ondeck;
        this.LlContactsService.setActiveContactId(this.bundle.selectedId);

        this.bundle.showRemaining = true;
      });
    }
  }

  noAction() {
    //needed HTML buttons point to this 
  }

  onKeyUp(event) {

    if (event.keyCode == 13) { ///Enter
      this.text_search.val(removeCarriageReturn(this.text_search.val()));
      this.search();
    }

    if (event.keyCode == 9) { ///Tab || Enter
      this.search();
    }
  }

  search() {

    this.popover_search.close()

    setTimeout(() => {
      this.bundle.searchText = this.text_search.val();

      if (this.bundle.searchText == "") {
        this.bundle.records = this.bundle.origionalRecords;
      } else {
        this.bundle.records = filter(this.bundle.origionalRecords, "FOLDERNAME", this.bundle.searchText);

        if (this.bundle.records.length > 0) {
          this.bundle.selectedId = this.bundle.records[0].FOLDERID;

          this.LlContactsService.setActiveContactId(this.bundle.selectedId);

        }
      }

      this.searchClick();
    });
  }

  clear() {
    this.bundle.records = this.bundle.origionalRecords;

    ///console.log(this.bundle.records)

    this.bundle.searchText = ""
    this.text_search.val("");
    let looking = true;

    for (var i = 0; i < this.bundle.records.length; i++) {

      if (this.bundle.records[i].FOLDERID > 0 && looking == true) {

        looking = false;

        this.popover_search.close()

        this.bundle.selectedId = this.bundle.records[i].FOLDERID;

        this.LlContactsService.setActiveContactId(this.bundle.selectedId);

        setTimeout(() => {

          //console.log("this.bundle.selectedId: " + this.bundle.selectedId)

          if (this.bundle.selectedId != null && document.getElementById(this.bundle.prefix + this.bundle.selectedId.toString()) != null) {
            document.getElementById(this.bundle.prefix + this.bundle.selectedId.toString()).click();
          }
        }, 200);
      }
    }
  }

  searchClick() {

    if (this.bundle.records.length == 0) {

      this.bundle.showTab = false;
      this.bundle.selectedId = -666

      this.LlScrollpaneService.paintVertTab(this.bundle);

    } else {

      let selectedId_local = this.bundle.records[0].FOLDERID;

      setTimeout(() => {

        if (selectedId_local != null && document.getElementById(this.bundle.prefix + selectedId_local.toString()) != null) {

          document.getElementById(this.bundle.prefix + selectedId_local.toString()).click();
        }

      });
    }

  }

  add() {

    this.bundle.newUserMsg = ""

    let validEmail = this.ValidateEmail(this.text_contactEmail.val())
    
    if (validEmail == false) {
      this.bundle.newUserMsg = "Invalid email format"

    }else if (this.text_contactFirst.val() == "" || this.text_contactLast.val() == "") {
      this.bundle.newUserMsg = "All fields are required"

    } else {
      this.bundle.popover_addContact = this.popover_addContact;
      this.bundle.getData = this.getData;

      this.LlContactsService.NG_LL_contact_add(this.returnedMessage, this.text_contactEmail.val(), this.text_contactFirst.val(), this.text_contactLast.val(), this.bundle);

    }
  }

  returnedMessage(msg, bundle) {

    if (msg == '') {
      bundle.popover_addContact.close();
      bundle.getData('exisiting', bundle);

    } else {
      bundle.newUserMsg = msg
    }    
  }

  ValidateEmail(inputText) {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (inputText.match(mailformat)) {
      return true;
    } else {
      return false;
    }
  }

}
